/**
 * @flow
 * @relayHash 7c829f6ea14d62a3d1d0d9e0c8073557
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type InfoStringList_viewer$ref = any;
export type InfoStringList_Refetch_QueryVariables = {|
  blockSlug: string
|};
export type InfoStringList_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: InfoStringList_viewer$ref
  |}
|};
export type InfoStringList_Refetch_Query = {|
  variables: InfoStringList_Refetch_QueryVariables,
  response: InfoStringList_Refetch_QueryResponse,
|};
*/


/*
query InfoStringList_Refetch_Query(
  $blockSlug: String!
) {
  viewer {
    ...InfoStringList_viewer_XeZ0m
    id
  }
}

fragment InfoStringList_viewer_XeZ0m on Viewer {
  infoStrings: infoStrings {
    edges {
      node {
        ...InfoStringListItem_item
        id
      }
    }
  }
  configurableBlock(slug: $blockSlug) {
    id
    type
    slug
    config
    active
  }
  articles: articleForInfoStrings(first: 100) {
    edges {
      node {
        ...ArticleListItem_article
        id
      }
    }
  }
}

fragment InfoStringListItem_item on InfoString {
  id
  title
  order
  infostring
  infostring_hot
}

fragment ArticleListItem_article on Article {
  id
  section
  title
  authorName
  categoryName
  availableAt
  hidden
  isArticleOfDay
  isArticleOfHour
  isEvent
  state
  mainPageOrder
  showInYandexNews
  showInYandexZen
  infostring
  infostring_hot
  mediaFiles {
    id
  }
  preview {
    type
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "blockSlug",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "infostring",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "infostring_hot",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "InfoStringList_Refetch_Query",
  "id": null,
  "text": "query InfoStringList_Refetch_Query(\n  $blockSlug: String!\n) {\n  viewer {\n    ...InfoStringList_viewer_XeZ0m\n    id\n  }\n}\n\nfragment InfoStringList_viewer_XeZ0m on Viewer {\n  infoStrings: infoStrings {\n    edges {\n      node {\n        ...InfoStringListItem_item\n        id\n      }\n    }\n  }\n  configurableBlock(slug: $blockSlug) {\n    id\n    type\n    slug\n    config\n    active\n  }\n  articles: articleForInfoStrings(first: 100) {\n    edges {\n      node {\n        ...ArticleListItem_article\n        id\n      }\n    }\n  }\n}\n\nfragment InfoStringListItem_item on InfoString {\n  id\n  title\n  order\n  infostring\n  infostring_hot\n}\n\nfragment ArticleListItem_article on Article {\n  id\n  section\n  title\n  authorName\n  categoryName\n  availableAt\n  hidden\n  isArticleOfDay\n  isArticleOfHour\n  isEvent\n  state\n  mainPageOrder\n  showInYandexNews\n  showInYandexZen\n  infostring\n  infostring_hot\n  mediaFiles {\n    id\n  }\n  preview {\n    type\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "InfoStringList_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "InfoStringList_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "blockSlug",
                "variableName": "blockSlug",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "InfoStringList_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "infoStrings",
            "name": "infoStrings",
            "storageKey": null,
            "args": null,
            "concreteType": "InfoStringConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "InfoStringEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InfoString",
                    "plural": false,
                    "selections": [
                      v1,
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "order",
                        "args": null,
                        "storageKey": null
                      },
                      v3,
                      v4
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "configurableBlock",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "slug",
                "variableName": "blockSlug",
                "type": "String"
              }
            ],
            "concreteType": "ConfigurableBlock",
            "plural": false,
            "selections": [
              v1,
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "config",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "articles",
            "name": "articleForInfoStrings",
            "storageKey": "articleForInfoStrings(first:100)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100,
                "type": "Int"
              }
            ],
            "concreteType": "ArticleConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ArticleEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Article",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "section",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "authorName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "categoryName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "availableAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hidden",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isArticleOfDay",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isArticleOfHour",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isEvent",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "mainPageOrder",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showInYandexNews",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "showInYandexZen",
                        "args": null,
                        "storageKey": null
                      },
                      v3,
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mediaFiles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MediaFile",
                        "plural": true,
                        "selections": [
                          v1
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preview",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MediaFile",
                        "plural": false,
                        "selections": [
                          v5,
                          v1
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6524651543e619fa23eb73811c2a1061';
module.exports = node;



// WEBPACK FOOTER //
// src/components/info-strings/__generated__/InfoStringList_Refetch_Query.graphql.js